module.exports = __webpack_public_path__ + "static/media/favicon.a031bdae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/favicon.svg
// module id = 677
// module chunks = 0